/**
 * InventoryTagItem.jsx
 * Created by Destin Frasier on 12/28/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    name: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    iconClass: PropTypes.string.isRequired,
    gray: PropTypes.bool
};

const defaultProps = {
    gray: false
};

const InventoryTagItem = ({ name, icon, iconClass, gray }) => (
    <li className={`rec-${iconClass}-tag ${gray ? 'alt' : ''}`} key={name} title={name}>
        {icon}
    </li>
);

InventoryTagItem.propTypes = propTypes;
InventoryTagItem.defaultProps = defaultProps;

export default InventoryTagItem;
